import { postflopOrder } from '../hand/positions';
/** limped / srp / 3bp / 4bp from the count of preflop raises (a limp/call is not a raise). */
const potTypeOf = (state) => {
    const bb = state.spec.stakes.bb;
    const raises = state.history.filter((h) => h.street === 'preflop' &&
        (h.action.kind === 'raise' || (h.action.kind === 'jam' && (h.action.amount ?? 0) > bb))).length;
    return raises === 0 ? 'limped' : raises === 1 ? 'srp' : raises === 2 ? '3bp' : '4bp';
};
/** Hero is in position iff hero is the last of the still-live seats in postflop action order. */
const heroPositionClass = (state) => {
    const n = state.players.length;
    const order = postflopOrder(n, state.buttonSeat);
    const live = order.filter((seat) => {
        const p = state.players.find((pp) => pp.seat === seat);
        return p && !p.folded;
    });
    return live[live.length - 1] === state.spec.heroSeat ? 'ip' : 'oop';
};
/** What hero is doing at this decision: acting into a check (cbet/lead) vs facing a bet, per street. */
const streetRole = (state) => {
    const hero = state.players.find((p) => p.seat === state.spec.heroSeat);
    const toCall = hero ? state.currentBet - hero.committedThisStreet : 0;
    const facing = toCall > 0;
    switch (state.street) {
        case 'preflop':
            return facing ? 'facing_raise' : 'checkable';
        case 'flop':
            return facing ? 'facing_cbet' : 'cbet';
        case 'turn':
            return facing ? 'facing_turn' : 'turn_bet';
        case 'river':
            return facing ? 'bluffcatch' : 'river_bet';
        default:
            return 'unknown';
    }
};
/** The canonical spot-family key for the hand at hero's decision point. */
export const classifySpot = (state) => `${potTypeOf(state)}_${heroPositionClass(state)}_${streetRole(state)}`;
//# sourceMappingURL=spot.js.map